import { createRef } from 'react';
import { AddCustomerModalGroupRef } from '../../../types';

export const addCustomerModalGroupRef = createRef<AddCustomerModalGroupRef>();
